import { useMemo } from "react";
import { useSignedImages } from "./useSignedImages";

/**
 * Presigns a batch of stored S3 URLs in one request and returns a
 * `stored URL -> presigned URL` lookup, so a whole page of thumbnails costs one
 * round trip instead of one per card.
 *
 * Falls back to the stored URL for anything that could not be signed, matching
 * `useSignedImages`.
 */
export function useSignedUrlMap(urls) {
  // The joined key doubles as the memo dependency: a plain array literal would
  // be a new reference on every render and re-run the memo (and the request).
  const key = (urls || []).filter(Boolean).join("|");

  const originals = useMemo(
    () => (key ? [...new Set(key.split("|"))] : []),
    [key]
  );
  const signed = useSignedImages(originals);

  return useMemo(
    () => new Map(originals.map((url, index) => [url, signed[index] || url])),
    [originals, signed]
  );
}

export default useSignedUrlMap;
